const LogoIcon = () => (
  <svg
    viewBox="0 0 64 64"
    className="w-[50px] h-[50px] block sm:w-[28px] sm:h-[28px]"
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* 🔍 Magnifying glass ring */}
    <circle
      cx="28"
      cy="28"
      r="18"
      fill="none"
      stroke="#21354e"
      strokeWidth="4"
    />

    {/* 🔍 Handle */}
    <line
      x1="40"
      y1="40"
      x2="56"
      y2="56"
      stroke="#4CAF50"
      strokeWidth="4"
      strokeLinecap="round"
    />

    {/* 📊 Bars */}
    <rect x="18" y="30" width="6" height="10" rx="1.5" fill="#4CAF50" />
    <rect x="26" y="26" width="6" height="14" rx="1.5" fill="#60A5FA" />
    <rect x="34" y="22" width="6" height="18" rx="1.5" fill="#A3E635" />

    {/* 📈 Trend line */}
    <path
      d="M16 28 L26 22 L34 26 L42 18"
      fill="none"
      stroke="#F59E0B"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default LogoIcon;